<template>
  <PaymentModal />
</template>

<script>
  import PaymentModal from './PaymentModal'
  export default {
    name: 'IndexModals',
    components: {
      PaymentModal
    },
    data () {
      return {
        //
      }
    }
  }
</script>